<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>CLIENT-SERVER COMMUNICATION</div>
				<h2 waHeading="l" waText>REST, Events, Data Services, and Real-Time</h2>
				<p waBody="m" waColorText="quiet" waText>Multiple patterns. Pick what fits. Layer them as you grow.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<p waBody="l" waText>JWebMP supports multiple client-server communication patterns &mdash; from traditional REST endpoints and server-driven AJAX events, through typed Angular data services, to real-time WebSocket messaging. You choose the right tool for each interaction. REST and AJAX work out of the box. Real-time is there when you need it. Explore each pattern via the menu tree.</p>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="brand">REST / Jakarta RS</wa-tag>
					<wa-tag pill variant="success">AJAX Events</wa-tag>
					<wa-tag pill variant="neutral">Data Services</wa-tag>
					<wa-tag pill variant="warning">Vert.x Event Bus</wa-tag>
					<wa-tag pill variant="danger">RabbitMQ</wa-tag>
				</div>
			</div>
		</div>
	</div>
</div>